import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from '@aws-amplify/core';

import {Group} from '@mantine/core';

import {ButtonPrimary} from 'pac-ux-components';

import {BackButton} from './BackButton';

const SubmitFormGroup = ({cancelUrl, submitButtonLabel, disabled}) => {

    return (
        <Group position="right">
            <BackButton cancelUrl={cancelUrl}/>

            <ButtonPrimary tabIndex={2} type="submit" disabled={disabled}>
                {I18n.get(submitButtonLabel)}
            </ButtonPrimary>
        </Group>
    );
};


export default SubmitFormGroup;

SubmitFormGroup.propTypes = {
    cancelUrl: PropTypes.string,
    submitButtonLabel: PropTypes.string,
    disabled: PropTypes.bool,
};

SubmitFormGroup.defaultProps = {
    submitButtonLabel: 'Submit',
    disabled: false,
};
